var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"clusterDetails"}},[(_vm.cluster.hasOwnProperty('data'))?[_c('div',{staticClass:"configurationDetails"},[_c('ClusterSummary',{attrs:{"cluster":_vm.crd,"extensionsList":_vm.extensionsList,"details":true}})],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }